import type { VideoEmbedProps } from "@op/puck-types";
// import LiteYouTubeEmbed from "react-lite-youtube-embed";

const VideoEmbed = ({ videoId: _videoId, title: _title }: VideoEmbedProps) => {
  return null;
  // return (
  //   <a href={`https://youtube.com/watch?v=${videoId}`} target="_blank">
  //     <div
  //       className="w-full h-auto aspect-video"
  //       style={{
  //         breakInside: "avoid-page",
  //       }}
  //     >
  //       <LiteYouTubeEmbed
  //         id={videoId}
  //         cookie={false}
  //         title={title}
  //         lazyLoad
  //         poster="hqdefault"
  //         playlist={false}
  //         adNetwork={false}
  //         alwaysLoadIframe={false}
  //         aspectWidth={16}
  //         aspectHeight={9}
  //         autoplay={false}
  //         muted={false}
  //         webp={true}
  //       />
  //     </div>
  //   </a>
  // );
};

export default VideoEmbed;
